import { useEffect, Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './AppToast.css';

import Loader from './components/Loader';
import { getRoutes } from './routes';
import PageContent from './pages/PageContent';

import MaintenancePage from './pages/MaintenancePage';
import SiteConfigContext from './contexts/SiteConfigContext';
import { UserSettingsProvider } from './contexts/UserSettingsContext';
import { UserProvider } from './contexts/UserContext';
import useSiteConfig from './services/useSiteConfig';

import { useAuth, useClerk } from '@clerk/clerk-react';
import ForceLogoutDialog from './pages/MaintenancePageComponents/ForceLogoutDialog';
import UpdateAvailableDialog from './components/UpdateAvailableDialog';
import ErrorDlg from './components/shared/ErrorSnack/ErrorDlg';
import CalendarWidget from './CalendarWidget';
import BodyEditorWidget from './BodyEditorWidget';
import JxWindowManagerPainter from './JxControls/JxWindowManager/JxWindowManagerPainter.jsx';
import AppContext from './controllers/AppContext';

function App() {
    const { isLoaded, userId } = useAuth();
    if (!isLoaded) return <Loader />;
    return <AppRoutes userId={userId} />;
}

function AppRoutes({ userId }) {
    const router = useRoutes(getRoutes(!!userId));

    const { siteConfig, updateAvailable, dismissUpdate } = useSiteConfig();

    const { isSignedIn, sessionClaims } = useAuth();

    const { signOut } = useClerk();

    const isAdmin = sessionClaims?.role === 'admin';

    // AppContext.init();

    useEffect(() => {
        document.title = 'Jerny';
    }, []);

    return (
        <PageContent>
            <UserProvider>
                <UserSettingsProvider>
                    <SiteConfigContext.Provider value={siteConfig}>
                        <ToastContainer toastClassName="toast-message" progressClassName="toast-progress" />
                        {isSignedIn && !isAdmin && siteConfig && !siteConfig.loginActive && (
                            <ForceLogoutDialog
                                message={siteConfig.loggedOnMsg}
                                onConfirm={() => {
                                    console.log('App.js - sign out');
                                    signOut();
                                }}
                            />
                        )}

                        <UpdateAvailableDialog open={updateAvailable} onDismiss={dismissUpdate} />

                        <ErrorDlg />

                        <CalendarWidget />

                        <BodyEditorWidget />

                        {/* Isolated repaint target — only re-renders when windows open/close/tab-switch */}
                        <JxWindowManagerPainter />

                        <Suspense fallback={<Loader />}>{router}</Suspense>
                    </SiteConfigContext.Provider>
                </UserSettingsProvider>
            </UserProvider>
        </PageContent>
    );
}

export default App;
